<template>
	<div class="row ml-1">
		<h1 class="font-medium">{{ title }}</h1>
		<slot name="subtitle"></slot>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			required: true
		}
	}
}
</script>
